<template>
  <div class="mainWeb">
    <el-dialog title="阈值设置"  :visible.sync="showyuzhi" width="1000px">
      <div style="margin-bottom:20px;">私教课名称：{{yuzhiObj.courseName}}</div>
      <el-form :model="formparamsYuzhi" :rules="rules" ref="formparamsYuzhi" label-width="135px">
        <el-form-item label="提前提醒剩余次数" prop="minvalue">
          <el-input class="w220" v-model.number="formparamsYuzhi.minvalue" placeholder="请输入提前提醒次数"></el-input>
        </el-form-item>
        <el-form-item label="过期提前提醒天数" prop="expireMinValue" v-if="iscourseDays">
          <el-input class="w220" v-model.number="formparamsYuzhi.expireMinValue" placeholder="请输入过期提前提醒天数"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetFormYuzhi('formparamsYuzhi')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitFormYuzhi('formparamsYuzhi')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="私教课程信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="100px">
          <el-form-item label="分店" prop="shopNum" v-if="isSelectShopNum">
            <el-select v-model="formparams.shopNum" placeholder="请选择" @change="selectShopNum">
              <el-option v-for="item in shopListNew"
              :key="item.id"
              :label="item.name"
              :value="item.shopNum"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="私教课价格" prop="actualPrice">
            <el-input class="w220" v-model="formparams.actualPrice" placeholder="请输入私教课价格"></el-input>
          </el-form-item>
          <!-- <el-form-item label="课程说明" prop="courseDetails">
            <el-input v-model="formparams.courseDetails" placeholder="请输入课程说明"></el-input>
          </el-form-item> -->
          <el-form-item label="任课教练" prop="jid">
            <el-select v-model="formparams.jid" placeholder="请选择任课教练">
              <el-option v-for="item in this.optionsJL"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="上课时常" prop="teachTime">
            <el-input v-model.number="formparams.teachTime" placeholder="请输入上课时常" maxlength="20"></el-input>
          </el-form-item> -->
          <el-form-item label="上课教室">
            <el-select v-model="formparams.classRoom" clearable  placeholder="请选择上课教室">
              <el-option v-for="item in this.roomList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="私教课类型" prop="mode">
            <el-input class="w220" v-model.number="formparams.mode" placeholder="私教类型（1V2/1V3 传1、2、3、4）" maxlength="20"></el-input>
          </el-form-item>
           <el-form-item label="课程说明" prop="courseDetails">
            <editor-bar v-model="formparams.courseDetails" :isClear="isClear"></editor-bar>
            <!-- <el-input type="textarea" rows="4"  v-model="formparams.courseDetails" placeholder="请输入卡说明"></el-input> -->
          </el-form-item>
          <!-- <el-form-item label="私教图片" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。
          </el-form-item> -->
        </el-form> 
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="私教图片"  :visible.sync="dialogVisible2" width="1000px">
      <el-form :model="formparamsAddImg" ref="formparamsAddImg" label-width="100px">
        <el-form-item label="私教图片" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
             *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetForm2('formparamsAddImg')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="addForm('formparamsAddImg')">确 定</el-button>
      </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table :data="tableDataOff" height="68vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" label="私教课程名"></el-table-column>
        <el-table-column prop="shortname" label="名称简写"></el-table-column>
        <el-table-column scope="scope" label="私教图片">
          <template slot-scope="scope">
            <img class="imgList" style="width:70px;height:70px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.imgurl" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="itemprice" label="私教课程金额"></el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div v-if="scope.row.isAllShop=='否'">{{scope.row.shopNum|changeType}}</div>
            <div v-else>通用</div>
          </template>
          
        </el-table-column>
        <!-- <el-table-column prop="remarks" label="说明"></el-table-column> -->
        <el-table-column width="350" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">修改图片</el-button>
            <el-button style="width:100px"  type="primary" @click="setThreshold(scope.row)">阈值设置</el-button>
            <el-button style="width:100px"  type="success" v-show="scope.row.state!=1" @click="addOnlineCard(scope.row)">上线</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
let that;
import {getInfI, insertTbPrivateCourse, getVieWEJt, getClassRoom, insertCardsSell, getShops,getThreshold,setThreshold} from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
import EditorBar from '../../components/wangEnduit'
export default {
  props:["tableDataOff","queryParams","shopListNew"],
  data() {
    return {
      loading: true,
      dialogVisible: false,
      dialogVisible2:false,
      showyuzhi: false,
      isClear: false,
      hideUpload:false,
      date:[],//开始时间结束时间
      isSelectShopNum: false,
      yuzhiObj: {
        courseName: '',
      },
      iscourseDays: false, //是否有过期时间
      rules:{
        minvalue: [
          { required: true, message: '请输入阈值', trigger: 'blur' },
        ],
        expireMinValue: [
          { required: true, message: '请输入阈值', trigger: 'blur' },
        ],
        actualPrice: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern:/^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/, message: '请输入正确金额格式', trigger: 'blur' }
        ],
        jid:[
          { required: true, message: '请选择教练', trigger: 'change' }
        ],
        shopNum:[
          { required: true, message: '请选择分店', trigger: 'change' }
        ],
        // classRoom:[
        //   { required: true, message: '请选择教室', trigger: 'change' }
        // ],
        description:[{ required:true,message:'请输入票说明',trigger:'blur' }],
        
        // teachTime:[
        //   { required: true, message: '请输入上课时长'},
        //   { type: 'number', message: '必选为数字'}
        // ],
        mode:[
          { required: true, message: '请输入私教类型'},
          { type:'number',min:1, message: '必选为大于0的数字'}
        ],
        // classDate: [
        //   { required: true, type: "array", message: '请选择时间', trigger: 'change' }
        // ]
      },
      formparams:{
        // courseStartTime:'',//开课时间
        // courseEndTime:'',//结束时间
        // classDate:[],
        actualPrice:'',//价格
        jid:'',//教练id
        iid:'',//私教课程id
        iShortName:'',//私教课程简称
        // teachTime:'',//上课时常
        shopNum:'',//分店编号
        courseDetails:'',//上课说明
        classRoom:'',//上课教室
        mode:'',//私教类型
      },
      formparamsYuzhi: {
        minvalue: '',
        expireMinValue: '',
        shortName: '',
        shopNum: ''
      },
      optionsJL:[],//教练列表
      roomList:[],//教室列表
      formData:{},
      formparamsAddImg:{},
      timeList:[],
      fileList:[],
      options:[],
      titleList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        name:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  components: {
    mainHead,
    EditorBar
  },
  beforeCreate(){
    that = this
  },
  created(){
    // this.getShopsList()
    // this.getShopsListWeb()
  },
  mounted() {
    // this.getTableList()
  },
  filters:{
    changeType(value){
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  methods: {
    selectShopNum(eventm) {
      this.getVieWEJt()
    },
    //查询线下私教私教课程
    getTableList(){
      this.params.shopNum = this.queryParams.shopNum
      this.params.name = this.queryParams.name
      getInfI(this.params).then((res)=>{
        if(res.msg=='success'){
          // this.tableDataOff = res.data.info
          this.$emit('getTableDataOff',res.data)
        }else {
          this.$message.error(res.data)
        }
        this.loading= false
      })
    },
    //查询教练
    getVieWEJt(){
      getVieWEJt({shopNum:this.formparams.shopNum}).then((res)=>{
        console.log(res)
        if(res.msg=='success'){
          this.optionsJL = res.data
          sessionStorage.setItem('optionsJL',JSON.stringify(res.data))
        }else {
          this.$message.error(res.data)
        }
      })
    },
    //查询教室
    getClassRoom(row){
      getClassRoom({shopNum:row,type:1}).then((res)=>{
        console.log(res)
        if(res.msg == 'success'){
          this.roomList = res.data
          sessionStorage.setItem('roomList',JSON.stringify(res.data))
        }
      })
    },
    addOnlineCard(row){
      if(!row.imgurl){
        this.$message.error('请先上传私教图片')
        return
      }
      this.getClassRoom(row.shopNum)
      this.dialogVisible= true
      this.formparams.actualPrice='',//价格
      this.formparams.jid='',//教练id
      this.formparams.iid='',//私教课程id
      this.formparams.iShortName='',//私教课程简称
      this.formparams.courseDetails='',//上课说明
      this.formparams.classRoom='',//上课教室
      this.formparams.mode='',//私教类型
      this.formparams.iid = row.id
      if(row.isAllShop=='是') {
        this.isSelectShopNum = true
      }else {
        this.isSelectShopNum = false
      }
      this.formparams.shopNum = row.shopNum
      this.getVieWEJt()
      this.formparams.iShortName = row.shortname
      this.clearForm('formparams')
    },

    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
     setThreshold(row) {
      if(row.courseDays!=0) {
        this.iscourseDays = true
        this.formparamsYuzhi.expireMinValue = null
      }else {
        this.iscourseDays = false
      }
      this.yuzhiObj.courseName = row.name
      this.formparamsYuzhi.shortName = row.shortname
      this.getThreshold(row.shopNum,row.shortname,'0')
      this.showyuzhi = true
    },
    // 查看项目阈值
    getThreshold(shopNum,shortName,type) {
      this.formparamsYuzhi.shopNum = shopNum
      getThreshold({shopNum:shopNum,shortName:shortName,type:type}).then(res=>{
        if(res.msg == 'success'){
          if(res.data.minvalue) {
            this.formparamsYuzhi.minvalue = res.data.minvalue
          }
          if(res.data.expireMinValue) {
            this.formparamsYuzhi.expireMinValue = res.data.expireMinValue
          }
        }else{
          this.$message.error(res.data)
        }
      })
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          this.formData = new FormData()
          // console.log(this.formparams.classDate)
          // this.formData.append('classDate', this.formparams.classDate)
          this.formData.append('actualPrice', this.formparams.actualPrice);
          this.formData.append('jid', this.formparams.jid);
          this.formData.append('iid', this.formparams.iid);
          this.formData.append('iShortName', this.formparams.iShortName);
          this.formData.append('shopNum', this.formparams.shopNum);
          this.formData.append('courseDetails', this.formparams.courseDetails);
          this.formData.append('classRoom', this.formparams.classRoom);
          this.formData.append('mode', this.formparams.mode);
          let config = {
              headers: {
                'Content-Type':'multipart/form-data',
                'token':sessionStorage.getItem('token')
              }
          }
          this.$http.post('ptClass/insertTbPrivateCourse', this.formData, config).then((res)=>{
            console.log(res)
            if(res.data.msg == 'success'){
              this.dialogVisible = false
              this.$message({
                type:'success',
                message:'添加成功'
              })
            } else {
              this.dialogVisible = false
              this.$message({
                type:'error',
                message:res.data.data
              })
            }
            this.params.pageNo = this.queryParams.pageNo
            this.params.pageSize = this.queryParams.pageSize
            this.getTableList()
          })
        } 
      });
    },
    submitFormYuzhi(formparamsYuzhi) {
      this.$refs[formparamsYuzhi].validate(valid => {
        if (valid) {
          setThreshold({minvalue:this.formparamsYuzhi.minvalue,expireMinValue:this.formparamsYuzhi.expireMinValue,shortName:this.formparamsYuzhi.shortName,shopNum:this.formparamsYuzhi.shopNum,type:0}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'设置成功'
              })
              this.formparamsYuzhi.minvalue = ''
              this.formparamsYuzhi.expireMinValue = ''
              this.resetFormYuzhi(this.formparamsYuzhi)
            }else{
              this.$message.error(res.data)
            }
          })
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
     //取消
    resetFormYuzhi(formparamsYuzhi) {
      this.showyuzhi = false;
      this.formparamsYuzhi.minvalue = ''
      this.formparamsYuzhi.expireMinValue = ''
      if(this.$refs[formparamsYuzhi]!=undefined){
        this.$refs[formparamsYuzhi].clearValidate();
      }
    },
    clearForm(formName) {
      this.$refs[formName].clearValidate();
    },
    resetForm2(formparamsAddImg) {
      this.dialogVisible2 = false;
      this.$refs[formparamsAddImg].clearValidate();
    },
      //分页
    // handleSizeChange(val) {
    //   this.params.size = val;
    //   this.params.page = 1;
    //   this.currentPage = 1;
    // },
    // handleCurrentChange(val) {
    //   this.params.page = val;
    // },
    edit(row){
      console.log(row)
      if(this.fileList){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.fileList=[]
      this.dialogVisible2 = true
      this.formparamsAddImg.shortName = row.shortname
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.imgurl})
    },
    async addForm(){
      this.formData = new FormData()
      this.$refs.upload.submit();
      if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('上传卡的图片不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
              this.$message.error('上传图片大小不能超过500kb');
              this.fileList= []
              this.hideUpload= false
              return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
      this.formData.append('shortName', this.formparamsAddImg.shortName);
      let config = {
          headers: {
            'Content-Type':'multipart/form-data',
            'token':sessionStorage.getItem('token')
          }
      }
      console.log(this.formData)
      // POST /ptClass/updatePrivateCourseImage
      const {data: res} = await this.$http.post('ptClass/updatePrivateCourseImage', this.formData, config)
      if(res.msg == 'success'){
        this.dialogVisible2 = false
        this.$message({
          type:'success',
          message:'添加成功'
        })
        
        this.params.pageNo = this.queryParams.pageNo
        this.params.pageSize = this.queryParams.pageSize
        this.getTableList()
      } else{
        this.dialogVisible = true
        this.$message.error(res.data);
      }
    },
  }
};
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// offlineCoach.vue?050db3b2